import CryptoJS from "crypto-js";

export function anonymize(input) {
  const hashedInput = CryptoJS.SHA256(input).toString();
  return hashedInput.substring(0, 10); // This will return the first 10 characters of the hash
}
